import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Button } from './ui/button';
import { Checkbox } from './ui/checkbox';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from './ui/dialog';
import { ScrollArea } from './ui/scroll-area';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

const PrivacyPolicyModal = ({ isOpen, onAccept }) => {
  const [accepted, setAccepted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleAccept = async () => {
    if (!accepted) {
      toast.error('Debes aceptar la política de privacidad para continuar');
      return;
    }

    setLoading(true);
    try {
      await axios.post(`${API_URL}/auth/accept-privacy`);
      onAccept();
    } catch (error) {
      toast.error('Error al aceptar la política de privacidad');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={() => {}}>
      <DialogContent className="max-w-3xl max-h-[90vh]" onPointerDownOutside={(e) => e.preventDefault()}>
        <DialogHeader>
          <DialogTitle className="text-xl font-bold text-slate-900">
            Política de Privacidad
          </DialogTitle>
          <DialogDescription>
            Para continuar usando la plataforma, debes aceptar nuestra política de privacidad.
          </DialogDescription>
        </DialogHeader>

        <ScrollArea className="h-[400px] pr-4">
          <div className="prose prose-sm max-w-none text-slate-700">
            <h3 className="text-lg font-semibold text-slate-900 mt-4">INTRODUCCIÓN</h3>
            <p>
              Su privacidad es importante para nosotros, así que, mediante este documento, le explicamos qué datos recogemos de los usuarios, como los utilizamos y para qué, entre otras indicaciones.
            </p>
            <p>
              Para su información, nunca pediremos más información de la que realmente necesitaremos para los servicios requeridos; nunca la compartiremos con terceros, excepto por obligación legal o con su autorización previa; y nunca utilizaremos sus datos para otra finalidad no indicada previamente.
            </p>
            <p>
              Como usuarios, deberá leer atentamente esta Política de privacidad de manera regular, y siempre que introduzca sus datos personales, ya que este documento puede sufrir modificaciones ya que el prestador puede modificar cualquier tipo de información que pudiera aparecer en la web para cumplir con la normativa o actualizar la política, y sin que exista la obligación de preavisar o poner en conocimiento de los usuarios dichas obligaciones, siendo suficientes la publicación en el sitio web del prestador.
            </p>

            <h3 className="text-lg font-semibold text-slate-900 mt-6">RESPONSABLE DEL TRATAMIENTO</h3>
            <ul className="list-none space-y-1">
              <li><strong>Identidad:</strong> IRTA ASISTENCIA MEDICA INTEGRAL, S.L.</li>
              <li><strong>NIF:</strong> B44507127</li>
              <li><strong>Dirección postal:</strong> Paseo Héroes de Marruecos, 67, 12570, Alcalá de Xivert, Castelló de la Plana</li>
              <li><strong>Correo electrónico:</strong> irtaserviciosasistenciales@gmail.com</li>
            </ul>

            <h3 className="text-lg font-semibold text-slate-900 mt-6">PROTECCIÓN DE DATOS</h3>
            <p>
              IRTA ASISTENCIA MEDICA INTEGRAL, S.L., como responsable del sitio web, de conformidad con lo dispuesto en el Reglamento (UE) 2016/679 de 27 de abril de 2016 (RGPD) relativo a la protección de las personas físicas en lo que respecta al tratamiento de datos personales y a la libre circulación de estos datos y demás normativa vigente en materia de protección de datos personales, y por la Ley 34/2002, de 11 de julio, de Servicios de la Sociedad de la Información y del Comercio Electrónico (LSSICE), le informa que tiene implementadas las medidas de seguridad necesarias, de índole técnica y organizativas, para garantizar y proteger la confidencialidad, integridad y disponibilidad de los datos introducidos.
            </p>

            <h3 className="text-lg font-semibold text-slate-900 mt-6">DERECHOS DEL USUARIO</h3>
            <p>
              El usuario tiene derecho a:
            </p>
            <ul className="list-disc pl-5 space-y-1">
              <li>Acceder a sus datos personales</li>
              <li>Solicitar la rectificación de datos inexactos</li>
              <li>Solicitar su supresión</li>
              <li>Solicitar la limitación de su tratamiento</li>
              <li>Oponerse al tratamiento</li>
              <li>Solicitar la portabilidad de sus datos</li>
            </ul>
            <p className="mt-2">
              Para ejercer estos derechos, puede contactar con nosotros en: <strong>irtaserviciosasistenciales@gmail.com</strong>
            </p>
          </div>
        </ScrollArea>

        <div className="border-t pt-4 mt-4">
          <div className="flex items-start space-x-3 mb-4">
            <Checkbox
              id="accept-privacy"
              checked={accepted}
              onCheckedChange={setAccepted}
            />
            <label
              htmlFor="accept-privacy"
              className="text-sm text-slate-700 cursor-pointer"
            >
              He leído y acepto la Política de Privacidad de IRTA ASISTENCIA MEDICA INTEGRAL, S.L.
            </label>
          </div>
          <Button
            onClick={handleAccept}
            className="w-full bg-[#004E89] hover:bg-[#003B66]"
            disabled={loading || !accepted}
          >
            {loading ? 'Aceptando...' : 'Aceptar y continuar'}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default PrivacyPolicyModal;
